import React from 'react';
const LOADING_SKELETON_CLASS = 'loading-skeleton';

export default function SearchPageSidebarSkeleton() {
    return (
        <div
            style={{
                display: 'flex',
                justifyContent:'space-between',
                alignItems: 'center',
                margin: '2em 0',
            }}
        >
            <div
                className={'w-100'}>
                {/* Price range title */}
                <div
                    className={LOADING_SKELETON_CLASS}
                    style={{
                        width: '50px',
                        marginBottom: '.5em',
                    }}
                />
                {/* Price range slider */}
                <div
                    className={LOADING_SKELETON_CLASS}
                    style={{
                        width: '90%',
                        marginBottom: '.5em',
                    }}
                />
                <div
                    style={{
                        display: 'flex',
                        justifyContent:'space-between',
                        alignItems: 'center',
                    }}
                >
                    {/* Vendor */}
                    <div
                        className={LOADING_SKELETON_CLASS}
                        style={{ width: '50%' }}
                    />
                </div>
            </div>
        </div>
    );
}